const translations = {
  // Navbar
  nav_home: "Strona Główna",
  nav_spreadsheet: "Spreadsheet",
  nav_categories: "Kategorie",
  nav_guides: "Poradniki",
  nav_shopping_guide: "Poradnik Zakupowy",
  nav_safety: "Bezpieczeństwo",
  nav_mobile_menu: "Menu",
  nav_mobile_close: "Zamknij",

  // Hero
  hero_tag: "Kakobuy Spreadsheet Polska 2026",
  hero_title_line1: "Kakobuy Spreadsheet Polska",
  hero_title_line2: "Najlepsze Znaleziska,",
  hero_title_line3: "Linki i Poradniki",
  hero_subtitle: "Znajdź tysiące sprawdzonych produktów Kakobuy w jednym miejscu. Nasz Kakobuy Spreadsheet pomaga szybciej wyszukiwać buty, ubrania, akcesoria i najlepsze okazje zakupowe.",
  hero_cta_primary: "Kakobuy Spreadsheet",
  hero_cta_secondary: "Kup Teraz",

  // Category Dropdown
  dropdown_label: "Wybierz Kategorię Produktów",
  dropdown_placeholder: "Kliknij, aby wybrać kategorię...",

  // Categories
  category_shoes: "Buty",
  category_hoodies: "Bluzy / Swetry",
  category_tshirts: "Koszulki",
  category_jackets: "Kurtki",
  category_pants: "Spodnie / Szorty",
  category_headwear: "Nakrycia Głowy",
  category_sets: "Zestawy",
  category_underwear: "Bielizna",
  category_jersey: "Koszulki Sportowe",
  category_accessories: "Akcesoria",
  category_bags: "Torby",
  category_belts: "Paski",
  category_perfumes: "Perfumy",
  category_other: "Inne Produkty",

  // SEO Content Sections
  section_what_is_title: "Co to jest Kakobuy Spreadsheet?",
  section_what_is_desc: "Kakobuy Spreadsheet to uporządkowana baza produktów zawierająca linki produktów, ceny, kategorie, popularne wybory użytkowników oraz informacje pomocne przed zakupem. To niezbędne narzędzie dla każdego, kto chce efektywnie kupować przez Kakobuy.",
  section_what_is_point1: "Linki do zweryfikowanych produktów z Chin",
  section_what_is_point2: "Aktualne ceny i dostępność produktów",
  section_what_is_point3: "Kategorie uporządkowane według popularności",
  section_what_is_point4: "Informacje o jakości i opinie użytkowników",

  section_why_title: "Dlaczego warto korzystać z Kakobuy Spreadsheet?",
  section_why_card1_title: "Oszczędzaj Czas",
  section_why_card1_desc: "Nie przeszukuj tysięcy produktów ręcznie. Wszystko masz w jednym, przejrzystym arkuszu.",
  section_why_card2_title: "Lepsze Produkty",
  section_why_card2_desc: "Znajduj popularne produkty wybrane i przetestowane przez społeczność Kakobuy.",
  section_why_card3_title: "Łatwiejsze Zakupy",
  section_why_card3_desc: "Porównuj produkty przed zamówieniem i podejmuj świadome decyzje zakupowe.",

  section_how_title: "Jak działa Kakobuy Spreadsheet?",
  section_how_step1_title: "Wybierz Kategorię",
  section_how_step1_desc: "Przeglądaj kategorie produktów, które Cię interesują - od butów po akcesoria.",
  section_how_step2_title: "Znajdź Produkt",
  section_how_step2_desc: "Korzystaj z linków i opisów, aby szybko znaleźć dokładnie to, czego szukasz.",
  section_how_step3_title: "Sprawdź Informacje",
  section_how_step3_desc: "Zapoznaj się ze szczegółami produktu, cenami i opiniami innych kupujących.",
  section_how_step4_title: "Przejdź do Zakupu",
  section_how_step4_desc: "Kliknij w link i przejdź bezpośrednio do produktu na platformie Kakobuy.",

  // Article Section on Homepage
  section_article_title: "Poradniki i Artykuły SEO",
  section_article_subtitle: "Poznaj Świat",
  section_article_subtitle_italic: "Kakobuy Spreadsheet",
  section_article_read_more: "Czytaj więcej →",
  section_article_view_all: "Zobacz Wszystkie Artykuły",

  // 9 Article card data for homepage
  article_card_1_title: "Kompletny Przewodnik Kakobuy Spreadsheet 2026",
  article_card_1_excerpt: "Wszystko, co musisz wiedzieć o Kakobuy Spreadsheet – od podstaw po zaawansowane triki.",
  article_card_2_title: "Kakobuy dla Początkujących – Od Zera do Zamówienia",
  article_card_2_excerpt: "Nigdy nie korzystałeś z Kakobuy? Ten przewodnik przeprowadzi Cię przez cały proces.",
  article_card_3_title: "Najlepsze Buty i Sneakersy w Kakobuy Spreadsheet",
  article_card_3_excerpt: "Klasyczne modele i limitowane edycje w świetnych cenach – sprawdź nasze top picks.",
  article_card_4_title: "Bluzy, Swetry i Hoodies – Przegląd Kakobuy",
  article_card_4_excerpt: "Stylowe bluzy i swetry w cenach 3-4 razy niższych niż w Polsce.",
  article_card_5_title: "Czy Kakobuy Jest Bezpieczny? Poradnik 2026",
  article_card_5_excerpt: "Ochrona kupującego, zdjęcia QC i sposoby na unikanie ryzyka.",
  article_card_6_title: "Wysyłka Kakobuy do Polski – Ceny i Czas",
  article_card_6_excerpt: "Porównanie metod wysyłki, kosztów i czasu dostawy do Polski.",
  article_card_7_title: "Akcesoria, Torby i Dodatki z Kakobuy",
  article_card_7_excerpt: "Torby, paski, okulary – modowe dodatki w niewiarygodnych cenach.",
  article_card_8_title: "Kakobuy vs Inne Platformy – Porównanie",
  article_card_8_excerpt: "Porównujemy Kakobuy z Pandabuy i Sugargoo – sprawdź, co wybrać.",
  article_card_9_title: "Trendy i Hity Kakobuy Spreadsheet 2026",
  article_card_9_excerpt: "Zobacz, co będzie modne – streetwear, sneakersy i akcesoria na ten rok.",

  // About / Trust Section
  section_about_tag: "O Kakobuy Spreadsheet",
  section_about_title_line1: "Twoje źródło",
  section_about_title_line2: "sprawdzonych produktów",
  section_about_desc: "Kakobuy Spreadsheet to największa polska baza produktów dostępnych przez platformę Kakobuy. Gromadzimy i aktualizujemy listy najlepszych znalezisk, abyś mógł kupować szybciej, taniej i bezpieczniej.",
  section_about_cta: "Przejdź do Kakobuy Spreadsheet",

  // CTA Section
  section_cta_title_line1: "Gotowy na",
  section_cta_title_line2: "najlepsze okazje",
  section_cta_title_line3: "z Kakobuy?",
  section_cta_button: "Zobacz Kakobuy Spreadsheet",

  // Testimonial
  testimonial_text: "Kakobuy Spreadsheet całkowicie zmienił sposób, w jaki robię zakupy. Oszczędzam godziny na szukaniu produktów i zawsze znajduję najlepsze okazje.",
  testimonial_name: "Anna Kowalska",
  testimonial_badge: "Zweryfikowany użytkownik Kakobuy",

  // FAQ
  section_faq_title: "Często Zadawane Pytania",
  faq_q1: "Czy Kakobuy Spreadsheet jest darmowy?",
  faq_a1: "Tak, Kakobuy Spreadsheet jest całkowicie darmowy. Udostępniamy wszystkie linki i informacje bez żadnych opłat. Naszym celem jest pomoc polskiej społeczności w łatwiejszym korzystaniu z platformy Kakobuy.",
  faq_q2: "Czy Kakobuy jest bezpieczny?",
  faq_a2: "Tak, Kakobuy jest legalną i bezpieczną platformą pośredniczącą w zakupach z Chin. Oferuje zdjęcia QC, ubezpieczenie przesyłek i ochronę kupującego. W naszym arkuszu znajdziesz tylko sprawdzone produkty od zaufanych sprzedawców.",
  faq_q3: "Jak znaleźć produkty w spreadsheet?",
  faq_a3: "Wystarczy wybrać interesującą Cię kategorię z listy - znajdziesz tam posegregowane produkty z bezpośrednimi linkami, opisami i cenami. Regularnie aktualizujemy listę o nowe znaleziska.",
  faq_q4: "Jak działa wysyłka do Polski?",
  faq_a4: "Kakobuy oferuje kilka metod wysyłki do Polski, w tym DHL, EMS i linie ekonomiczne. Czas dostawy wynosi zazwyczaj od 7 do 21 dni, w zależności od wybranej metody. Koszty wysyłki zależą od wagi paczki.",
  faq_q5: "Jak często aktualizowany jest spreadsheet?",
  faq_a5: "Nasz zespół regularnie aktualizuje Kakobuy Spreadsheet - dodajemy nowe produkty, usuwamy niedostępne linki i sprawdzamy aktualność cen co tydzień. Dzięki temu zawsze masz dostęp do świeżych informacji.",
  faq_q6: "Czy potrzebuję konta Kakobuy?",
  faq_a6: "Tak, aby dokonać zakupu przez linki z naszego arkusza, potrzebujesz konta na platformie Kakobuy. Rejestracja jest darmowa i zajmuje tylko kilka minut.",
  faq_q7: "Jakie produkty znajdę w spreadsheet?",
  faq_a7: "W naszym arkuszu znajdziesz szeroki wybór produktów: buty sportowe i casualowe, odzież (bluzy, koszulki, kurtki, spodnie), akcesoria (torby, paski, czapki), perfumy oraz wiele innych kategorii.",
  faq_q8: "Czy mogę sugerować produkty do dodania?",
  faq_a8: "Oczywiście! Jesteśmy otwarci na sugestie społeczności. Jeśli znalazłeś ciekawy produkt na Kakobuy, daj nam znać, a sprawdzimy go i dodamy do arkusza.",
  faq_q9: "Czy produkty są oryginalne?",
  faq_a9: "W arkuszu znajdują się zarówno produkty oryginalne, jak i wysokiej jakości reprezentacje. Każdy produkt jest odpowiednio oznaczony, abyś wiedział dokładnie, co kupujesz.",
  faq_q10: "Jak mogę wesprzeć projekt?",
  faq_a10: "Najlepszym wsparciem jest korzystanie z naszych linków i dzielenie się Kakobuy Spreadsheet ze znajomymi. Im większa społeczność, tym więcej świetnych znalezisk możemy wspólnie odkrywać!",

  // Footer
  footer_title_line1: "Kakobuy Spreadsheet",
  footer_title_line2: "Polska",
  footer_subtitle: "Największa polska baza produktów Kakobuy. Znajdź najlepsze okazje, linki i poradniki zakupowe w jednym miejscu.",
  footer_newsletter_label: "Bądź na bieżąco",
  footer_newsletter_button: "Zapisz się",
  footer_col1_title: "Kategorie",
  footer_col1_link1: "Buty",
  footer_col1_link2: "Bluzy / Swetry",
  footer_col1_link3: "Koszulki",
  footer_col1_link4: "Kurtki",
  footer_col1_link5: "Akcesoria",
  footer_col2_title: "Przydatne Linki",
  footer_col2_link1: "Kakobuy Spreadsheet",
  footer_col2_link2: "Poradnik dla Początkujących",
  footer_col2_link3: "Bezpieczeństwo Zakupów",
  footer_col2_link4: "Wysyłka do Polski",
  footer_col3_title: "Kontakt",
  footer_col3_link1: "kaspreadsheet.com",
  footer_copyright: "© 2026 Kakobuy Spreadsheet Polska. Wszelkie prawa zastrzeżone.",

  // Article Page
  article_breadcrumb_home: "Strona Główna",
  article_breadcrumb_current: "Artykuł",
  article_keyword_table_title: "Analiza Gęstości Słów Kluczowych",
  article_keyword_col_keyword: "Słowo Kluczowe",
  article_keyword_col_count: "Wystąpienia",
  article_keyword_col_density: "Gęstość",

  // Article CTA
  article_cta_title: "Gotowy, aby zacząć?",
  article_cta_desc: "Przeglądaj nasze kategorie produktów i znajdź najlepsze okazje na Kakobuy już teraz.",
  article_cta_button: "Przejdź do Strony Głównej",

  // Article Related
  article_related_title: "Powiązane Artykuły i Kategorie",
  article_related_link1: "Kakobuy Spreadsheet - Strona Główna",
};

export default translations;